import type { ReactNode } from "react";

type Tone = "default" | "raised" | "muted";
type Density = "default" | "compact";

interface Props {
  title?: ReactNode;
  subtitle?: ReactNode;
  children: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  tone?: Tone;
  density?: Density;
  className?: string;
}

const toneClass: Record<Tone, string> = {
  default: "bg-surface border-border shadow-soft",
  raised: "bg-surface border-border shadow-card",
  muted: "bg-surface-2 border-border shadow-none",
};

export default function Card({
  title,
  subtitle,
  children,
  actions,
  footer,
  tone = "default",
  density = "default",
  className = "",
}: Props) {
  // Tighter gutters on a phone: 20px of card padding inside 16px of page
  // padding left ~318px of usable width on a 390px screen.
  const padHeader =
    density === "compact" ? "px-3 py-2.5 sm:px-4" : "px-4 py-3 sm:px-5";
  const padBody = density === "compact" ? "p-3 sm:p-4" : "p-4 sm:p-5";
  return (
    <div className={`rounded-lg border ${toneClass[tone]} ${className}`}>
      {(title || actions || subtitle) && (
        <div className={`flex items-start justify-between border-b border-border ${padHeader}`}>
          <div>
            {title && <div className="font-medium text-fg">{title}</div>}
            {subtitle && <div className="mt-0.5 text-xs text-muted">{subtitle}</div>}
          </div>
          {actions && <div className="shrink-0">{actions}</div>}
        </div>
      )}
      <div className={padBody}>{children}</div>
      {footer && (
        <div className={`border-t border-border ${padHeader} text-sm text-muted`}>
          {footer}
        </div>
      )}
    </div>
  );
}
